export default "/images/vendor/flag-icon-css/flags/4x3/jp.svg?d7ff64ff596ec31992b4a7af00b65a83";